export default "__VITE_ASSET__C2Lq568r__"